import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { createTheme, FormLabel, IconButton, Popover, Stack, ThemeProvider, Typography } from '@mui/material';
import {  useMemo, useState } from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import { useAppSettings } from '../../contexts/app-context/AppContext';
import { useOrganizations } from '../../queries/organizations/UseOrganizations';
import { useQueryNotifications } from '../../queries/UseQueryNotifications';
import { IOrganization } from '../../services/organization-data-service/Models';
import OrganizationHierarchy from '../organization-hierarchy/desktop/OrganizationHierarchy';
import MobileOrganizationPicker from './MobileOrganizationPicker';

export type OrganizationPickerProps = {
    label?: string;
    organizationID: number;
    onSelected: (item: IOrganization) => void;
    color?: string;
    includeAllOption?: boolean;
};

export default function OrganizationPicker({
    label,
    organizationID,
    onSelected,
    color,
    includeAllOption
}: OrganizationPickerProps) {

    const isPhone = isMobile && !isTablet;
    const [popOverAnchorEl, setPopOverAnchorEl] = useState<HTMLElement | undefined>();  
   
    const [appSettings] = useAppSettings();
    const { data: organizations } = useQueryNotifications(useOrganizations)({
        includeAllOption
    });

    const organization = organizations?.find(o => o.id === organizationID);

    const mainTheme = useMemo(
        () => {
            return createTheme(appSettings.themeSet[appSettings.themeSet.mode].main);
        },
        [appSettings.themeSet]
    );

    // const theme = useMemo(
    //     () => {
    //         return isPhone ? createTheme(appSettings.themeSet[appSettings.themeSet.mode].appHeaderV2) :
    //             createTheme(appSettings.themeSet[appSettings.themeSet.mode].main);
    //     },
    //     [appSettings.themeSet,
    //         isPhone]
    // );

    const openPopOver = Boolean(popOverAnchorEl);
    const id = openPopOver ? 'org-popover' : undefined;        


    const onShowPopOver = (event: React.MouseEvent<HTMLElement>) => {
        setPopOverAnchorEl(event.currentTarget);
      };
    
    const onClosePopOver = () => {
        setPopOverAnchorEl(undefined);
    };

    const onOrganizationChanged = (item: IOrganization) => {
        onSelected(item);
        onClosePopOver();
    }

    const onClosePicker = (item?: IOrganization) => {

        if (item) {
            onSelected(item);
        }

        onClosePopOver();
    }

    return (
        <>
            {
                label &&  <FormLabel component="legend">{label}</FormLabel>
            }
            <Stack
                direction='row'
                spacing={1}
                onClick={(e) => onShowPopOver(e)}
                sx={{
                    marginTop: theme => label ? `${theme.spacing(.5)}!important` : undefined,
                    cursor: 'pointer',
                    alignItems: "center",
                    //flex: '1 1 auto'
                }}>
            <Typography
                variant={isPhone || label ? 'body1' : 'body2'}
                component="div"
                sx={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    display: 'flex',
                    paddingLeft: theme => theme.spacing(label ? 1 : isPhone ? 7 : 3),
                    marginTop: 'auto',
                    marginBottom: 'auto'
                }}>
                {organization?.displayText}
            </Typography>
            <IconButton
                // sx={{ color: color ?? (isPhone ? '#fff' : undefined) }}
                sx={{ color: color ?? (isPhone ? '#fff' : "inherit") }}
                aria-label="related"
                aria-controls="organization-menu"
                aria-haspopup="true"
                >
                {openPopOver ? <ExpandLess /> : <ExpandMore /> }
            </IconButton>

            </Stack>
            {!isPhone ? 
            <ThemeProvider theme={mainTheme}>
                <Popover 
                    id={id}
                    open={openPopOver}
                    anchorEl={popOverAnchorEl}
                    onClose={onClosePopOver}
                    anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                    }}
                    sx={{
                        maxWidth: 800,
                        //marginBottom: 1
                    }}
                >
                    <OrganizationHierarchy 
                        includeAllOption={includeAllOption}
                        organizationID={organizationID} 
                        onSelected={onOrganizationChanged}                            
                    />
                </Popover>
            </ThemeProvider>

            :
            <MobileOrganizationPicker 
                includeAllOption={includeAllOption}
                open={openPopOver} 
                onClose={onClosePicker} 
                organizationID={organizationID} 
            />
            
            }
        </>
    );
  }



